import { InputAdornment, SxProps, TextField } from '@mui/material';
import { MdSearch } from '@teamworksdev/icons';
import { useTranslation } from 'react-i18next';

interface SearchInputProps {
  value: string;
  onChange: (searchTerm: string) => void;
  fullWidth?: boolean;
  label?: string;
  placeholder?: string;
  showLabel?: boolean;
  sx?: SxProps;
}

export const SearchInput = ({
  value,
  onChange,
  fullWidth = false,
  label,
  placeholder,
  showLabel = true,
  sx,
}: SearchInputProps) => {
  const { t } = useTranslation();
  const searchLabel = label || t('search');

  return (
    <TextField
      label={showLabel ? searchLabel : undefined}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      fullWidth={fullWidth}
      inputProps={!showLabel ? { 'aria-label': searchLabel } : undefined}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <MdSearch size={24} className="ml-0 pl-0" aria-hidden="true" />
          </InputAdornment>
        ),
      }}
      sx={sx}
    />
  );
};
